import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import type { CompanyRole } from '@/features/permissions/domain/permission'
import type { User, UserPort } from '../domain/user'

const withAbsoluteAvatar = (user: User): User =>
	user.avatarUrl && user.avatarUrl.startsWith('/')
		? { ...user, avatarUrl: `${pb.baseURL}${user.avatarUrl}` }
		: user

const pbUsers: UserPort = {
	list: async () => {
		const result = await tryCatch(pb.send<User[]>('/api/members', { method: 'GET' }))
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data.map(withAbsoluteAvatar)
	},

	create: async (data: { fullName: string; email: string; companyRole: CompanyRole }) => {
		const result = await tryCatch(
			pb.send<User>('/api/members', {
				method: 'POST',
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json' },
			}),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return withAbsoluteAvatar(result.data)
	},

	updateRole: async (id: string, companyRole: CompanyRole) => {
		const result = await tryCatch(
			pb.send<User>(`/api/members/${id}/role`, {
				method: 'PATCH',
				body: JSON.stringify({ companyRole }),
				headers: { 'Content-Type': 'application/json' },
			}),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return withAbsoluteAvatar(result.data)
	},
}

export { pbUsers }
